import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { PVAStyle, LoadingIndicator } from '../../components';
import { SurveyVersion, Style } from '../../models';
import { StyleDataService, ReportDataService } from '../../services';
import { FilterStore } from '../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';

interface PVAStylesState {
    orgId: number;
    surveyId: number;
    surveyVersionId: number;
    surveyVersion: SurveyVersion | undefined;
    styles: Style[];
    open: boolean;
    generating: boolean;
}

interface UserScoreProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
}

@inject('FilterStore') @observer
export class PVAStylesView extends React.Component<UserScoreProps, PVAStylesState> {
    private styleDataService = new StyleDataService(this.props.notificationService);
    private reportDataService = new ReportDataService(this.props.notificationService);

    constructor(props: UserScoreProps) {
        super(props);

        this.state = {
            orgId: 0,
            surveyVersionId: 0,
            surveyId: 0,
            surveyVersion: undefined,
            styles: [],
            open: false,
            generating: false
        };
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }
    
    public Update() {
        if (this.surveyVersion && this.surveyVersion.id !== this.state.surveyVersionId) {
            // pull down pva styles
            this.setState({
                surveyVersionId: this.surveyVersion.id
            });
            
            this.styleDataService.getAllBySurveyVersion(this.surveyVersion).then( (styles: Style[]) => {
                this.setState({
                    styles: styles
                });
            });
        }
    }

    public componentDidMount() {
        this.Update();
    }

    componentWillReact() {
        this.Update();
    }

    private GetTextType(style: Style, languageId: Number, textType: String) {
        if (!style.styleTexts || style.styleTexts.length === 0) {
            return '';
        }

        var text = style.styleTexts.filter((x => x.languageId === languageId && x.styleTextType === textType));
        if (text && text.length > 0) {
            return text[0].value;
        }
        return '';
    }

    private exportPDF(id: number, name: string) {
        this.setState(
            {
                generating: true
            },
            () => {
                this.reportDataService.getStylePDF(id, name).then(() => {
                    this.setState({
                        generating: false
                    });
                }).catch(() => {
                    this.setState({
                        generating: false
                    });
                });
            }
        );
    }

    private ActionsButton(stylesToList: Style[]) {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Export </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    <li className="options-header">PDF</li>
                    
                    {stylesToList.map((s: Style) => {
                        return <li key={`style-${s.id}`} className="options-entry" onClick={(e) => this.exportPDF(s.id, s.name)}>
                            <div className="options-entry-title">
                                <span>{s.name} PDF</span>
                            </div>
                        </li>;
                    })}

                </ul>
        </div>);
    }

    public render() {
        if (this.state.generating) {
            return <LoadingIndicator showPdfDescription={true} showInPanel={true} showBackground={true} />;
        }

        var stylesToList: Style[] = [];
        var stylesAdded = {};
        this.state.styles.map((s: Style) => {
            if (stylesAdded[s.name] === undefined) {
                stylesAdded[s.name] = s.name;
                stylesToList.push(s);
            }
        });

        return (
            <div>
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}

                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-sm-10 col-md-8 col-xs-12">    
                                <div className="title">
                                    The 8 PVA Styles
                                </div>
                            </div>
                            <div className="col-sm-2 col-md-4 text-right">
                                {this.ActionsButton(stylesToList)}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        {stylesToList.map((s: Style) => {
                            return <PVAStyle notificationService={this.props.notificationService} name={' '} key={s.id} style={s} brief={this.GetTextType(s, 1, 'brief')} content={this.GetTextType(s, 1, 'content')} hideViewAll={true} />;
                        })}
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/pvastyles/PVAStylesView.tsx